import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';

//Redux setup
import { Provider } from 'react-redux';
import store from './store';

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);